import { useContext } from "react";
import { EnumerationsContext } from "@/contexts/EnumerationsContext";

export const useEnumerations = () => {
  return useContext(EnumerationsContext);
};
